import { tap, switchMap, map, catchError } from 'rxjs/operators';
import { Component, Inject } from '@angular/core';
import { AppStateService } from 'src/app/Services/AppState/app-state.service';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Observable, of, defer } from 'rxjs';
import { rutValidator } from 'src/app/Services/Utils/Validators/rut.validator';
import { COUNTRY_CODES } from 'src/app/Models/CountryCodes/country-codes';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { MatInputModule } from '@angular/material/input';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-user-info',
  templateUrl: './user-info.component.html',
  styleUrls: ['./user-info.component.scss'],
  standalone: true,
  imports: [
    CommonModule
    , MatInputModule
    , MatFormFieldModule
    , ReactiveFormsModule
    , MatSelectModule
    , NgxSkeletonLoaderModule
    , RouterModule
  ],
  providers: [
    { provide: MAT_DIALOG_DATA, useValue: {} }
  ]
})
export class UserInfoComponent {
  form: FormGroup = new FormGroup({
    rut: new FormControl('', [Validators.required, rutValidator]),
    firstName: new FormControl('', [Validators.required]),
    lastName: new FormControl('', [Validators.required]),
    firstEmail: new FormControl('', [Validators.required, Validators.email]),
    secondEmail: new FormControl('', [Validators.email]),
    phone: new FormControl('', [Validators.required]),
    countryCode: new FormControl('', [Validators.required]),
    accountID: new FormControl('', [Validators.required]),
  });
  countryCodes = COUNTRY_CODES;
  selectedCode = '';
  selectedCountryCode: string = '';
  selectedPhone: string = '';
  loading$: Observable<any>;
  showRutField = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: string,
    public appStateService: AppStateService
  ) {
    this.loading$ = of(this.fromModal).pipe(
      switchMap((c) => {
        return defer(() =>
          !!c
            ? this.appStateService.UserService.GetUserInfo(data).pipe(
              map(({ success, userData }) => ({ success, data: userData }))
            )
            : this.appStateService.AccountService.GetDataUser().pipe(
              map(({ success, updateAccountInput }) => ({
                success,
                data: updateAccountInput,
              }))
            )
        );
      }),
      tap(({ data, success }) => {
        if (success) {
          const {
            accountID,
            rut,
            firstName,
            lastName,
            firstEmail,
            secondEmail,
            phone,
            countryCode
          } = data;


          this.selectedCountryCode = countryCode ? '+' + String(countryCode).replace(/^\+/, '') : '';
          this.selectedPhone = phone || '';
          if (phone) {
            const phoneParts = phone.trim().split(/\s+/);
            if (phoneParts.length === 2) {
              this.selectedCountryCode = '+' + phoneParts[0].replace(/^\+/, '');
              this.selectedPhone = phoneParts[1];
            } else {
              this.selectedPhone = phone;
            }
          }


          this.form.patchValue({
            accountID,
            firstName,
            rut,
            lastName,
            firstEmail,
            secondEmail,
            phone: this.selectedPhone,
            countryCode: this.selectedCountryCode
          });
          this.showRutField = this.fromModal || !!this.form.get('rut')?.invalid;

        }
      }),
      catchError(() => of({ success: false, data: null }))
    );
  }

  /**
   * @description Permite identificar si el componente fue invocado en un modal
   */
  get fromModal(): boolean {
    const _ = this.data,
      __ = typeof _;
    return __ === 'string';
  }

  SendForm() {
    if (this.form.invalid || this.appStateService.loading) {
      this.form.markAllAsTouched();
      return;
    }
    const value = { ...this.form.getRawValue() };
    const phoneParts = value.phone.split(' ');

    if (phoneParts.length === 2) {
      value.countryCode = phoneParts[0].replace('+', '');

      value.phone = value.countryCode + " " + phoneParts[1];
    } else {
      value.countryCode = value.countryCode.replace('+', '');

      value.phone = value.countryCode + " " + value.phone;
    }

    this.appStateService.AccountService.UpdateCurrentUser(value);
  }

  onCountryCodeChange(selectedCode: string) {
    this.selectedCountryCode = selectedCode;
    this.form.get('countryCode')?.setValue(selectedCode);
  }
}
